import React from 'react';
import { formatCurrency } from '../../utils/helpers';

const ServiceCard = ({ service, onClick }) => {
  return (
    <div className="service-card" onClick={onClick}>
      <div className="service-card-header">
        {service.imageUrl && (
          <img 
            src={service.imageUrl} 
            alt={service.name}
            className="service-image"
          />
        )}
        <div className="service-info">
          <h3>{service.name}</h3>
        </div>
      </div>
      
      <div className="service-meta">
        <div className="meta-item">
          <span>⏱️</span>
          <strong>{service.duration || 60} min</strong>
        </div>
        <div className="meta-item">
          <span>💰</span>
          <strong>{formatCurrency(service.price || 0)}</strong>
        </div>
      </div>

      <div className="service-footer">
        <button className="select-button">
          Select Service
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;

